import React, { useEffect, useState } from "react";
import { FaInstagram, FaLinkedin, FaEnvelope } from "react-icons/fa";
import { Typewriter } from "react-simple-typewriter";

function About() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const iconBaseClass = "w-6 h-6 md:w-7 md:h-7 text-slate-700 transition-all duration-200 hover:scale-110";

  return (
    <section id="about" className="max-w-5xl mx-4 md:mx-auto mt-8 md:mt-10">
      <div
        className={
          "hero-card p-6 md:p-10 flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-10 transition-all duration-700 " +
          (visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3")
        }
      >
        <img
          src="/logo192.png"
          alt="Profilbild"
          className="w-24 h-24 md:w-36 md:h-36 rounded-3xl border border-white/70 shadow-xl"
        />

        <div className="text-center md:text-left">
          <p className="uppercase tracking-[0.18em] text-xs font-bold text-cyan-700 mb-2">
            Softwareentwicklung & Prozessoptimierung
          </p>

          <h1 className="text-3xl md:text-5xl font-black text-slate-900 leading-tight">
            Ich bin Marko Piljak
          </h1>

          <p className="text-lg md:text-2xl mt-3 text-slate-700 font-semibold min-h-[42px]">
            <Typewriter
              words={[
                "Leidenschaftlicher Softwareentwickler",
                "Tech-Enthusiast",
                "Spezialist für Prozessautomatisierung"
              ]}
              loop={0}
              cursor
              cursorStyle="|"
              typeSpeed={60}
              deleteSpeed={100}
              delaySpeed={1500}
            />
          </p>

          <p className="text-base md:text-lg text-slate-600 mt-4 max-w-2xl">
            Ich entwickle digitale Lösungen, die manuelle Abläufe reduzieren, Teams entlasten
            und interne Geschäftsprozesse messbar effizienter machen.
          </p>

          <div className="flex gap-4 md:gap-5 mt-6 justify-center md:justify-start">
            <a href="https://instagram.com/marko.piljak" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram className={iconBaseClass + " hover:text-rose-500"} />
            </a>
            <a href="https://www.linkedin.com/in/DEIN-LINKEDIN-NAME" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin className={iconBaseClass + " hover:text-sky-600"} />
            </a>
            <a href="mailto:DEINE-MAIL@domain.com" aria-label="E-Mail">
              <FaEnvelope className={iconBaseClass + " hover:text-amber-500"} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;